import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_CONTACT_PERSON_MASTER,
  EDIT_CONTACT_PERSON_MASTER,
  GetContactPersonDataByID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";

import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";
import "./AddContactPersonMaster.scss";
import SelectDataFromTable from "../../SeletFromDatable/SelectDataFromTable";
import { AccoutDetails } from "../AddCustomerAccount/AddCustomerAccount";
import { ConvertDateValues } from "../../../custom_hooks/ChangeDateValues";
import Button from "../../Button/Button";
import { extractIds } from "../../SeletFromDatable/convartdataintoIds";

const getOrionPages = gql`
  query GetAllPagesWithUserType($userType: String! = "Customer") {
    getAllPagesWithUserType(userType: $userType) {
      Name
      Unique_Id
      _id
    }
  }
`;
const AddContactPersonMaster = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const Form_Key = "Contact_Person_Master";
  const [isFirstLoad, setFirstLoad] = useState(false);
  const formRef = useRef({});
  const initialPagesRef = useRef([]);
  const [FormData, setFormdata] = useState({});
  const { pushModal, popModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const [ConfirmMerge, SetConfirmMerge] = useState(false);
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Contact_Person_Master?.Selected_Row;
  const [selectedRows, setSelectedRows] = useState([]);
  const [allFieldsData, setAllFieldsData] = useState({});
  const [showAccounsts, setShowAccounts] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [pages, setPages] = useState([]);
  const [AccountsData, setAcountsData] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [initialData, setInitialData] = useState({});

  const selectedIds = useSelector(
    (store) => store?.UniqueTableReducer?.[`Select_Table_Data_${Form_Key}`]?.Selected_Rows
  );
  const { isDisabled } = useIsDisabled({
    TypeOfPortal,
    initial: { ...initialData, pages: initialPagesRef.current },
    current: { ...FormData, pages },
  });

  const { data: AccountQiery } = useQuery(AccoutDetails, {
    fetchPolicy: "network-only",
    onCompleted: (res) => {
      if (res?.AccountsByAccountType?.length) {
        setAcountsData(ConvertDateValues(res?.AccountsByAccountType));
      }
    },
  });

  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });
  const [getDataById, { loading: getDataByIdLoader }] = useLazyQuery(GetContactPersonDataByID, {
    fetchPolicy: "no-cache",
  });

  const [EditingData, { loading: editContactPersonMasterLoading }] = useMutation(EDIT_CONTACT_PERSON_MASTER);
  const [CreatingData, { loading: createContactPersonMasterLoading }] = useMutation(CREATE_CONTACT_PERSON_MASTER);

  const { data: PagesData } = useQuery(getOrionPages, {
    skip: TypeOfPortal !== "Add",
    context: {
      headers: {
        "X-GraphQL-Server": "orion", // this triggers the orionLink
      },
    },
    onCompleted: (data) => {
      if (data.getAllPagesWithUserType) {
        const apipages = data.getAllPagesWithUserType?.map((el) => {
          return {
            Page_Name: el.Name,
            Page_Id: el._id,
            Page_Access: false,
          };
        });
        setPages(apipages);
      }
    },
  });

  const handlePageCheckboxChange = (pageIndex) => {
    setPages((prevPages) =>
      prevPages.map((page, idx) => (idx === pageIndex ? { ...page, Page_Access: !page.Page_Access } : page))
    );
  };
  const PackagingMasterLoadingState =
    createContactPersonMasterLoading || editContactPersonMasterLoading || getDataByIdLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next);
      }
      return next;
    });
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (selectedIds?.length && !showAccounsts) {
      // console.log(selectedIds, "selectedIds");
      setSelectedAccounts(selectedIds);
    }
  }, [selectedIds, showAccounsts]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Contact_Person_Master?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (inputFields?.length) {
      if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
        getDataById({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let ContactPersonData = { ...data?.getAccountPersonByID };
          // dispatch({
          //   type: "StoreMasterData",
          //   payload: {
          //     formkey: Form_Key,
          //     data: {
          //       Refered_To: ContactPersonData?.Refered_To_Data,
          //     },
          //   },
          // });
          // if (ContactPersonData?.Refered_To) {
          //   ContactPersonData.Refered_To = ContactPersonData?.Refered_To_Data?.Search_Value;
          // }
          const pagesData = data?.getAccountPersonByID?.pageRights?.map((el) => {
            return {
              Page_Name: el.Page_Name,
              Page_Id: el.Page_Id,
              Page_Access: el.Page_Access,
            };
          });
          if (pagesData?.length) setPages(pagesData);
          initialPagesRef.current = pagesData;
          if (ContactPersonData?.Refered_To?.length) {
            setSelectedAccounts(extractIds(ContactPersonData?.Refered_To));
          }
          setAllFieldsData(ContactPersonData);
          updateValueForm(formRef, ContactPersonData);
        });
      }
      // else {
      //   if (ReferenceFieldName?.length > 0) {
      //     console.log(ReferenceFieldName, "abc1");
      //     let abc = ReferenceFieldName[0]?.FieldName.Reference_field[0];
      //     console.log(abc, "abc2");
      //     dispatch({
      //       type: "StoreMasterData",
      //       payload: {
      //         formkey: Form_Key,
      //         data: {
      //           Refered_To: FormDataFromRedux.MasterData[ReferFormKey]?.[abc],
      //         },
      //       },
      //     });

      //     updateValueForm(formRef, {
      //       Refered_To: FormDataFromRedux?.MasterData[ReferFormKey]?.[abc]?.Search_Value,
      //     });
      //   } else {
      //     setAllFieldsData({});
      //   }
      // }
    }
  }, [fielddata, inputFields]);

  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, FormData, selectedRows);
  const MutationFunctions = {
    CreatingData,
    EditingData,
    // MergingData,
  };

  const Closeformfunction = () => {
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
    dispatch({ type: "DELETE_UNIQUE_TABLE_KEY", payload: { key: `Select_Table_Data_${Form_Key}` } });
    ParentPortalCloseFunction();
    settoggle(false);
  };

  const submit = async (closeAction) => {
    // FormData.Refered_To = FormDataFromRedux?.MasterData[Form_Key]?.Refered_To?._id;
    FormData.Refered_To = extractIds(selectedAccounts);
    FormData.pageRights = pages;
    FormData.Contact = FormData?.Contact ? String(FormData?.Contact) : "";
    const mutationFunction = getMutationFunction(operationType, MutationFunctions);

    let Name = ReferenceFieldName[0]?.FieldName?.name;
    console.log(FormData, "FormDataFormData");
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: FormData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: (res) => {
          // console.log(ReferFormKey, res);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createAccountPerson || res?.data?.editAccountPerson,
              },
            },
          });
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),

      onSuccess: (res) => {
        console.log(res);
      },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const ConfirmModalOpen = () => {
    SetConfirmMerge(true);
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => Validate_handleSubmit(SaveAndCloseForAdd)
          : TypeOfPortal === "Merge"
          ? () => ConfirmModalOpen()
          : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={PackagingMasterLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " Contact Person"}
        >
          {PackagingMasterLoadingState && <div className="loader-line-div" />}
          <div className="formContainer">
            {inputFields && inputFields?.length > 0 ? (
              inputFields.map((e) => (
                <div key={e.id} className="FormSectionParent">
                  <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                  <div className="selectCustomermaindiv">
                    <Button
                      name="SelectCustomerBtn"
                      text={"Select Customers"}
                      action={() => setShowAccounts(true)}
                      type={""}
                      children={""}
                      disabled={""}
                    ></Button>
                  </div>
                  <div className="FormSection insidecontainer">
                    <FormInputSectionComponent
                      handelformikdata=""
                      inputfields={e.fields}
                      Type={e.name}
                      TypeOfPortal={TypeOfPortal}
                      onErrorsChange={handleErrorsChange}
                      formkey={Form_Key}
                      onhandleFormikChange={HanldeChangeonForm}
                      formRef={formRef}
                      setFirstLoad={setFirstLoad}
                    />
                  </div>
                </div>
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p>No form fields available</p>
            ) : null}

            <div className="orion-pageshow-container">
              <div className="page-names-heading">App Pages</div>
              <div className="page-names-conainer">
                {pages?.length &&
                  pages.map((page, idx) => (
                    <label key={idx} style={{ display: "block", marginBottom: "6px", fontSize: "14px", color: "#333" }}>
                      <input
                        type="checkbox"
                        style={{ marginRight: "8px" }}
                        checked={page.Page_Access}
                        onChange={() => handlePageCheckboxChange(idx)}
                      />
                      {page.Page_Name}
                    </label>
                  ))}
              </div>
            </div>
          </div>
        </Reactportal>
      </div>
      {ConfirmMerge && (
        <Confirm
          submit={submit}
          settoggle={SetConfirmMerge}
          toggle={ConfirmMerge}
          loadingState={PackagingMasterLoadingState}
          submitType={"Confirm Merge"}
          TypeOfPortal={"Confirm"}
          message={`Are you sure you want to Merge this Record?`}
        />
      )}
      {showAccounsts && (
        <SelectDataFromTable
          data={AccountsData}
          selectedRows={selectedAccounts}
          TypeOfPortal={TypeOfPortal}
          toggle={showAccounsts}
          setToggle={setShowAccounts}
          TableKey={Form_Key}
        />
      )}
    </>
  );
};

export default AddContactPersonMaster;
